import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boldText',
})
@Injectable({
  providedIn: 'root',
})
export class BoldTextPipe implements PipeTransform {
  public transform(text: string, ...args: any[]): string {
    return text?.length > 0 ? `<b>${text}</b>` : text;
  }
}
